import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import styles from "src/Assets/css/home/post.module.css";
import { styled } from "@mui/material/styles";
import { Avatar, Divider } from "@mui/material";
import { Button } from "@mui/material";
import location from "src/Assets/images/locationpinchildpost.png";
import crown from "src/Assets/images/crown.png";
import API from "../../../network";
import dot from "src/Assets/images/dot.png";
import CircularProgress from "@material-ui/core/CircularProgress";

const Container = styled("div")({
  backgroundColor: "#fff",
  margin: "20px",
  borderRadius: "20px",
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  boxSizing: "border-box",
});

const CrownDiv = styled("div")({
  alignSelf: "flex-end",
  marginBottom: "1px",
});

const Status = styled("div")({
  width: "12px",
  height: "12px",
  borderRadius: "12px",
  alignSelf: "flex-end",
  marginBottom: "6px",
});

const UserName = styled("div")({
  fontSize: "14px",
  fontWeight: "700",
  color: "#333",
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

const MessageTime = styled("div")({
  fontSize: "12px",
  color: "#373334",
  opacity: "85%",
});

const NameContainer = styled("div")({
  flex: 1,
  flexDirection: "column",
  display: "flex",
  minWidth: 0,
  wordBreak: "break-word",
  overflowWrap: "break-word",
});

function UnblockRequest(props) {
  const { tenantId } = props || {};
  const { decreaseUnblockRequestCount } = props;
  // const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const [unblockRequests, setUnblockRequests] = useState([]);
  const [isUnblockReqLoading, setIsUnblockReqLoading] = useState(true);

  useEffect(() => {
    getUnblockRequests();
  }, [tenantId]);

  const getUnblockRequests = async () => {
    if (tenantId) {
      setIsUnblockReqLoading(true);
      setUnblockRequests([]);
      try {
        const response = await API.getModeratorActionItems(tenantId);
        if (
          response?.data?.UnblockUserRequests &&
          Array.isArray(response.data.UnblockUserRequests)
        ) {
          setUnblockRequests(response.data.UnblockUserRequests || []);
          setIsUnblockReqLoading(false);
        }
      } catch (e) {
        console.error(e);
        setIsUnblockReqLoading(false);
      }
    }
  };

  const getFormData = (tenantId, messageId, category, requestType, userId) => {
    let approveIdsValue = "";
    if (category === "Message") {
      approveIdsValue = `msg_${messageId}`;
    } else if (category === "Request to follow community") {
      approveIdsValue = `followreq_${userId}_${tenantId}`;
    } else if (category === "Report abuse") {
      approveIdsValue = `abs_${messageId}`;
    } else if (category === "New moderator") {
      approveIdsValue = `user_${userId}_${tenantId}`;
    } else if (category === "Request to unblock community") {
      approveIdsValue = `unblockReq_${userId}_${tenantId}_${messageId}`;
    }

    approveIdsValue =
      requestType === "approve"
        ? `${approveIdsValue}_1`
        : `${approveIdsValue}_0`;
    console.info(approveIdsValue);

    let formData = new FormData();
    formData.append("approveIds", approveIdsValue);
    return formData;
  };

  const approveAction = (
    messageId,
    category,
    tenantId,
    userId,
    indexToRemove
  ) => {
    const formData = getFormData(
      tenantId,
      messageId,
      category,
      "approve",
      userId
    );
    API.moderatorApproveDeny(formData)
      .then((res) => {
        const updatedData = unblockRequests.filter(
          (_, index) => index !== indexToRemove
        );
        setUnblockRequests(updatedData);
        decreaseUnblockRequestCount && decreaseUnblockRequestCount();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getCurrentStatusColor = (Keyword_ID) => {
    switch (Keyword_ID) {
      case "Open ASK":
      case "OpenASK":
      case "ASK":
        return "#2168b2";
      case "SAY":
      case "OpenSAY":
        return "#45a735";
      case "Important Update":
      case "UPDATE":
      case "impupdate":
        return "#e82727";
      case "#tag":
      case "#TAG":
      case "hashTAG":
      case "H":
        return "#efba29";
      default:
        return "transparent";
    }
  };

  const onReject = async (
    messageId,
    category,
    tenantId,
    userId,
    indexToRemove
  ) => {
    try {
      const formData = getFormData(
        tenantId,
        messageId,
        category,
        "reject",
        userId
      );
      await API.moderatorApproveDeny(formData);
      const updatedData = unblockRequests.filter(
        (_, index) => index !== indexToRemove
      );
      setUnblockRequests(updatedData);
      decreaseUnblockRequestCount && decreaseUnblockRequestCount();
    } catch (e) {
      console.error(e);
    }
  };

  const getKey = (item) =>
    item?.messageId
      ? `key-messageId-${item.messageId}`
      : `key-userId-${item.userId}`;

  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

  console.log(`unblockRequests:`, unblockRequests);

  return (
    <>
      {unblockRequests.length === 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          {isUnblockReqLoading ? (
            <div className="d-flex flex-direction-row justify-content-center">
              <CircularProgress size={30} />
            </div>
          ) : (
            <p>No Unblock Requests are available !</p>
          )}
        </div>
      ) : (
        unblockRequests.map((item, index) => (
          <Container key={index}>
            <div style={{ display: "flex" }}>
              <Avatar
                src={`${profileImagePath}${
                  item.category === "Report abuse"
                    ? item.createdByImage
                    : item.userImage
                }`}
                className={styles.avatar}
                variant="square"
              />
              <NameContainer>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <UserName>
                    {item.category === "Report abuse"
                      ? item.createdByName
                      : item.displayName}
                  </UserName>
                  {item.category === "Report abuse" && (
                    <UserName>
                      <span style={{ color: "#666" }}>Reported by </span>
                      <span>{item.displayName}</span>
                      <span style={{ color: "#666" }}> as </span>
                      <span>{item.reason}</span>
                    </UserName>
                  )}
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <MessageTime>{item.createdDate}</MessageTime>
                  {item.locName && (
                    <>
                      <img style={{ marginLeft: "3px" }} src={dot} alt="dot" />
                      <img
                        src={location}
                        style={{ width: 8, marginLeft: 7, marginRight: "3px" }}
                        alt="location"
                      />
                      <MessageTime>{item.locName}</MessageTime>
                    </>
                  )}
                </div>
              </NameContainer>
            </div>
            <div
              style={{
                fontSize: "14px",
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "pre-wrap",
                maxWidth: "100%",
              }}
            >
              {item.message}
            </div>
            {/* <div style={{ marginTop: "6px" }}>
            {item.followCount} followers. {item.hashTagType}
          </div> */}
            {String(item?.category).toLowerCase() === "new moderator" ? (
              <CrownDiv>
                <img src={crown} style={{ width: 12 }} alt="crown" />
              </CrownDiv>
            ) : (
              <Status
                style={{
                  backgroundColor: getCurrentStatusColor(item.Keyword_ID),
                  height: "13px",
                  width: "13px",
                  borderRadius: "36px",
                  marginRight: "10px",
                }}
              />
            )}
            <Divider variant="fullWidth" />
            {item?.category !== "Report abuse" ? (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    approveAction(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index
                    )
                  }
                >
                  Approve
                </Button>
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    onReject(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index
                    )
                  }
                >
                  Reject
                </Button>
              </div>
            ) : (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    onReject(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index
                    )
                  }
                >
                  Ignore
                </Button>
                <Button
                  style={{
                    padding: "5px 20px",
                    borderWidth: "0px",
                    borderRadius: "20px",
                    minWidth: "40%",
                    textTransform: "none",
                    backgroundColor: "#EFEEED",
                    color: "#373334",
                    fontWeight: "400",
                  }}
                  onClick={() =>
                    approveAction(
                      item.messageId,
                      item.category,
                      item.tenantId,
                      item.userId,
                      index
                    )
                  }
                >
                  Remove
                </Button>
              </div>
            )}
          </Container>
        ))
      )}
    </>
  );
}
export default UnblockRequest;
